import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { WorkshopUpdateRequest } from '../api/types';
import config from '../config';
import { Duration } from '../constants';

async function getWorkshopUpdateRequest(axios: AxiosInstance, id: number): Promise<WorkshopUpdateRequest> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/workshop-update-request/` + id);
  return data;
}

export default function useWorkshopUpdateRequestQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getWorkshopUpdateRequest(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
    staleTime: Duration.Minute,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['WorkshopUpdateRequest', id] as const satisfies QueryKey;
}

useWorkshopUpdateRequestQuery.getKey = getKey;
